import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import intl from 'react-intl-universal';
import { Box, Typography, makeStyles, Container } from '@material-ui/core';
import { Button, colors } from '@lifesize/clients.mui-components';
import { theme } from 'theme';
import { ReactComponent as LsBuddy } from '@lifesize/ux-assets/vectors/svgLogos/lsBuddy.svg';
import { openLoginPage } from 'redux/loginSlice';
import { RootState } from 'redux/rootReducer';
import { resetSnackBar } from 'redux/snackBarSlice';
import Alert from '@material-ui/lab/Alert';

const SignOut = () => {
  const classes = signOutStyle();
  const dispatch = useDispatch();
  const snackBarState = useSelector((state: RootState) => state.snackBar);

  const handleSignIn = () => {
    snackBarState.message && dispatch(resetSnackBar());
    dispatch(openLoginPage());
  };

  return (
    <Container className={classes.container}>
      {snackBarState.message && (
        <Alert id={'popUpBlockedByUserAlert'} severity="error">
          {intl.getHTML('popUpBlockedByUser')}
        </Alert>
      )}
      <LsBuddy className={classes.lsBuddy} />
      <Box pt={2} mb={3}>
        <Typography data-testid="signedOutText" variant="h4">
          {intl.get('signedOut')}
        </Typography>
      </Box>
      <Box>
        <Button data-testid="signInBtn" color="primary" variant="contained" onClick={handleSignIn}>
          {intl.get('signIn')}
        </Button>
      </Box>
    </Container>
  );
};

const signOutStyle = makeStyles(() => ({
  container: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    '& > :first-child': {
      marginBottom: theme.spacing(2)
    }
  },
  lsBuddy: {
    width: 50,
    height: 50,
    color: colors.lifesize
  }
}));

export default SignOut;
